import { Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';

import { takeUntil, tap } from 'rxjs/operators';

import { DateRange } from '@common/models';
import { PopupTooltipBaseComponent, PopupTooltipCloseEventType, PopupTooltipRef } from '@ui/misc/popup-tooltip';

import { PopupRangeParameters } from './utils';
import { PopupRangeService } from './utils/popup-range.service';

@Component({
    selector: 'aa-popup-range',
    templateUrl: './popup-range.component.html',
    styleUrls: [
        './popup-range.component.scss'
    ],
    providers: [
        PopupRangeService,
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PopupRangeComponent extends PopupTooltipBaseComponent<PopupRangeParameters> implements OnInit, OnDestroy
{
    @Input() hasActionButtons: boolean = true;
    @Output() popupRangeClosed: EventEmitter<DateRange> = new EventEmitter<DateRange>();
    @Output() popupRangeChanged: EventEmitter<DateRange> = new EventEmitter<DateRange>();

    constructor (
        host: ElementRef<HTMLElement>,
        popupTooltipRef: PopupTooltipRef,
        private popupRangeService: PopupRangeService
    )
    {
        super(host, popupTooltipRef);
    }

    ngOnInit (): void
    {
        this.popupRangeService.initConfig(this.parameters);
        this.popupRangeService.rangeConfig
            .pipe(
                tap(() =>
                    this.popupRangeChanged.emit(this.popupRangeService.dateRange)
                ),
                takeUntil(this.destroyator)
            )
            .subscribe();
        this.popupTooltipRef.closeEvent
            .pipe(
                tap((popupTooltipCloseEventType: PopupTooltipCloseEventType) =>
                    this.popupRangeClosed.emit(this.popupRangeService.dateRange)
                ),
                takeUntil(this.destroyator)
            )
            .subscribe();
    }

    ngOnDestroy ():void
    {
        this.destroyator.next(null);
        this.destroyator.complete();
    }

    public onApply = ():void =>
    {
        this.popupRangeClosed.emit(this.popupRangeService.dateRange);
    };

    public onReset = ():void =>
    {
        this.popupRangeService.resetRange();
    };

    public onCancel = ():void =>
    {
        this.popupRangeClosed.emit(this.popupRangeService.initRange);
    };
}
